import { render, staticRenderFns } from "./ReleasesArtistsReadOnlyPanel.vue?vue&type=template&id=7a20c3b2"
import script from "./ReleasesArtistsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesArtistsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./ReleasesArtistsReadOnlyPanel.vue?vue&type=style&index=0&id=7a20c3b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports